import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["article"]

  connect() {
    this.createProgressBar()
    this.boundUpdateProgress = this.updateProgress.bind(this)
    window.addEventListener('scroll', this.boundUpdateProgress)
    window.addEventListener('resize', this.boundUpdateProgress)
  }

  disconnect() {
    this.removeProgressBar()
    window.removeEventListener('scroll', this.boundUpdateProgress)
    window.removeEventListener('resize', this.boundUpdateProgress)
  }

  createProgressBar() {
    // Remove any existing progress bar first
    this.removeProgressBar()

    this.progressBar = document.createElement('div')
    this.progressBar.className = 'reading-progress'
    this.progressBar.setAttribute('data-reading-progress', 'true')
    document.body.appendChild(this.progressBar)

    // Initialize progress
    this.updateProgress()
  }

  removeProgressBar() {
    const existingBar = document.querySelector('[data-reading-progress]')
    if (existingBar) {
      existingBar.remove()
    }
  }

  updateProgress() {
    if (!this.hasArticleTarget || !this.progressBar) return

    const article = this.articleTarget
    const scrollTop = window.pageYOffset
    const docHeight = article.offsetHeight
    const winHeight = window.innerHeight
    const scrollPercent = scrollTop / Math.max(docHeight - winHeight, 1)
    const scrollPercentRounded = Math.round(scrollPercent * 100)

    // Ensure we don't exceed 100% and handle edge cases
    const clampedPercent = Math.max(0, Math.min(scrollPercentRounded, 100))

    document.documentElement.style.setProperty('--scroll', clampedPercent + '%')
  }
}
